import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { waLink } from "@/lib/businessInfo";

const FloatingWhatsApp = () => {
    const [show, setShow] = useState(false);
    const [tipOpen, setTipOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 200);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        const tipTimer = setTimeout(() => setTipOpen(true), 1800);
        const tipHide = setTimeout(() => setTipOpen(false), 7000);
        return () => {
            window.removeEventListener("scroll", onScroll);
            clearTimeout(tipTimer);
            clearTimeout(tipHide);
        };
    }, []);

    return (
        <div
            className={`fixed bottom-6 right-6 z-[100] transition-all duration-500 ${
                show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"
            }`}
        >
            {tipOpen && (
                <div className="absolute bottom-[72px] right-0 bg-white border border-slate-100 shadow-[0_20px_40px_rgba(0,0,0,0.12)] rounded-sm px-4 py-3 w-[230px] text-[13px] text-slate-700">
                    <button
                        onClick={() => setTipOpen(false)}
                        className="absolute top-1.5 right-2 text-slate-400 hover:text-slate-700 text-xs"
                        aria-label="Close tooltip"
                    >
                        ✕
                    </button>
                    <div className="font-semibold text-slate-900">Need a quick quote?</div>
                    <div className="mt-1 text-slate-500">
                        Chat with us on WhatsApp — we usually reply within minutes.
                    </div>
                    <span className="absolute -bottom-1.5 right-7 w-3 h-3 bg-white rotate-45 border-r border-b border-slate-100" />
                </div>
            )}
            <a
                data-testid="whatsapp-floating-btn"
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat on WhatsApp"
                className="sg-wa-pulse flex items-center justify-center w-[60px] h-[60px] rounded-full bg-[#25D366] text-white hover:bg-[#1DA851] shadow-[0_12px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
            >
                <MessageCircle className="w-7 h-7" strokeWidth={2.2} fill="white" />
            </a>
        </div>
    );
};

export default FloatingWhatsApp;
